import { jsx as w } from "react/jsx-runtime";
import b, { useState as U, useRef as S, useEffect as y, useMemo as N } from "react";
import k from "react-modal";
import { MenuColumnTheme as I } from "../interfaces.js";
import O from "./MenuColumn/MenuColumn.js";
import { getNavId as P } from "./helpers.js";
import { MenuContent as B } from "./styled.js";
const G = 3, K = Array.from({ length: G }, (o, r) => r), T = [
  I.DARK_GREY,
  I.BLUE_GREY,
  I.BLUE_GREY_75
], E = (o, r) => K.map(
  (d) => Array.from({ length: d }, (c, s) => s).reduce(
    (c, s) => {
      var l;
      return ((l = c[r[s + 1]]) == null ? void 0 : l.subItems) || [];
    },
    o
  )
), V = ({
  items: o,
  openMenu: r,
  onClose: d,
  setOpenMenu: c,
  headerHeight: s = 100,
  appElement: l
}) => {
  const [u, p] = U([]), L = (t) => (e) => {
    p([...r.slice(1, t), e]), c((n) => [...n.slice(0, t), e]);
  }, R = E(o, r), v = S(R);
  y(() => {
    v.current = E(o, r);
  }, [o, r]);
  const A = N(() => ({
    overlay: {
      backgroundColor: "rgba(142, 144, 147, 0.6)",
      top: `${s}px`,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      zIndex: 100
    },
    content: {
      position: "static",
      width: "calc(100% - 16px)",
      maxWidth: "1482px",
      margin: "8px 8px 0 8px",
      borderRadius: "0",
      border: "none",
      padding: "0"
    }
  }), [s]), g = !!r.length;
  y(() => {
    var t;
    try {
      if (u.length) {
        c((n) => [n[0], ...u]);
        const e = P(
          u.length - 1,
          u[u.length - 1]
        );
        (t = document.getElementById(e)) == null || t.focus();
      }
    } catch {
    }
  }, [u, c]);
  const m = b.useCallback((t) => {
    p((e) => {
      const n = v.current, i = e[e.length - 1], h = n[e.length - 1].length, a = (f) => [...e.slice(0, -1), f], C = () => i === h - 1 ? a(0) : a(i + 1), D = () => a(i === 0 ? h - 1 : i - 1), x = () => {
        var f;
        return (f = n[e.length]) != null && f.length ? [...e, 0] : e;
      }, _ = () => e.length > 1 ? e.slice(0, -1) : e;
      switch (t.key) {
        case "Tab":
          return t.preventDefault(), t.stopPropagation(), t.shiftKey ? D() : C();
        case "PageDown":
        case "ArrowDown":
          return t.preventDefault(), C();
        case "PageUp":
        case "ArrowUp":
          return t.preventDefault(), D();
        case "ArrowRight":
          return t.preventDefault(), x();
        case "ArrowLeft":
          return t.preventDefault(), _();
        case "Home":
          return t.preventDefault(), a(0);
        case "End":
          return t.preventDefault(), a(h - 1);
        default:
          return e;
      }
    });
  }, []);
  return y(() => (g ? (p([-1]), document.addEventListener("keydown", m, !0)) : document.removeEventListener("keydown", m, !0), () => {
    document.removeEventListener("keydown", m, !0);
  }), [g, m]), /* @__PURE__ */ w(
    k,
    {
      isOpen: g,
      style: A,
      onRequestClose: d,
      appElement: l ?? document.body,
      children: /* @__PURE__ */ w(B, { children: R.map((t, e) => {
        var n;
        return /* @__PURE__ */ w(
          O,
          {
            colNum: e,
            activeId: (n = t[r[e + 1]]) == null ? void 0 : n.id,
            items: t,
            onSelect: L(e + 1),
            colorScheme: T[e]
          },
          e
        );
      }) })
    }
  );
};
export {
  V as default
};
